import { render, staticRenderFns } from "./EtsyShop.vue?vue&type=template&id=e97fbb68"
import script from "./EtsyShop.vue?vue&type=script&lang=js"
export * from "./EtsyShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports